import React from "react";

const Loading = ({ h }) => {
  return (
    <div className="w-full flex justify-center my-10">
      <div class="flex space-x-2 justify-center items-center  ">
        <span class="sr-only">Loading...</span>
        <div class="h-5 w-5 bg-[#3e41e9]/70 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div class="h-5 w-5 bg-[#3e41e9]/70 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div class="h-5 w-5 bg-[#3e41e9]/70 rounded-full animate-bounce"></div>
      </div>
    </div>
  );
};

export default Loading;
